/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { EnqueteNewPageContentUserVariableDefinitionFragmentDoc } from './EnqueteNewPageContent.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type EnqueteNewPageQueryVariables = Exact<{ [key: string]: never; }>;


export type EnqueteNewPageQuery = { userVariableDefinitions: Array<{ guid: string, name: string, value:
      | { __typename: 'UserVariableDefinitionValueMultipleSelect', options: Array<{ guid: string, name: string }> }
      | { __typename: 'UserVariableDefinitionValueSelect', options: Array<{ guid: string, name: string }> }
      | { __typename: 'UserVariableDefinitionValueString', void: any }
      | { __typename: 'UserVariableDefinitionValueText', void: any }
     }> };


export const EnqueteNewPageDocument = gql`
    query EnqueteNewPage {
  userVariableDefinitions {
    ...EnqueteNewPageContentUserVariableDefinition
  }
}
    ${EnqueteNewPageContentUserVariableDefinitionFragmentDoc}`;

/**
 * __useEnqueteNewPageQuery__
 *
 * To run a query within a Vue component, call `useEnqueteNewPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useEnqueteNewPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useEnqueteNewPageQuery();
 */
export function useEnqueteNewPageQuery(options: VueApolloComposable.UseQueryOptions<EnqueteNewPageQuery, EnqueteNewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EnqueteNewPageQuery, EnqueteNewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EnqueteNewPageQuery, EnqueteNewPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<EnqueteNewPageQuery, EnqueteNewPageQueryVariables>(EnqueteNewPageDocument, {}, options);
}
export function useEnqueteNewPageLazyQuery(options: VueApolloComposable.UseQueryOptions<EnqueteNewPageQuery, EnqueteNewPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<EnqueteNewPageQuery, EnqueteNewPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<EnqueteNewPageQuery, EnqueteNewPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<EnqueteNewPageQuery, EnqueteNewPageQueryVariables>(EnqueteNewPageDocument, {}, options);
}
export type EnqueteNewPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<EnqueteNewPageQuery, EnqueteNewPageQueryVariables>;